export default __webpack_public_path__ + "media/Number12.7e5510bdb957a00cb30eb6ec67cc0656.mp4";